"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditButtons = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@material-ui/core");
var react_1 = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var icon_definitions_1 = require("../../atoms/icon-definitions");
var Root = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n"], ["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n"])));
exports.EditButtons = (0, react_1.memo)(function (_a) {
    var tooltipMessages = _a.tooltipMessages, onUndoClick = _a.onUndoClick, onRedoClick = _a.onRedoClick, onRemoveSelectedClick = _a.onRemoveSelectedClick, onRemoveAllClick = _a.onRemoveAllClick, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    return disabled ? (react_1.default.createElement(Root, null,
        react_1.default.createElement(core_1.IconButton, { disabled: true },
            react_1.default.createElement(icon_definitions_1.UndoIcon, null)),
        react_1.default.createElement(core_1.IconButton, { disabled: true },
            react_1.default.createElement(icon_definitions_1.RedoIcon, null)),
        react_1.default.createElement(core_1.IconButton, { disabled: true },
            react_1.default.createElement(icon_definitions_1.RemoveElementIcon, null)),
        react_1.default.createElement(core_1.IconButton, { disabled: true },
            react_1.default.createElement(icon_definitions_1.RemoveAllIcon, null)))) : (react_1.default.createElement(Root, null,
        react_1.default.createElement("div", { title: tooltipMessages.undo },
            react_1.default.createElement(core_1.IconButton, { onClick: onUndoClick },
                react_1.default.createElement(icon_definitions_1.UndoIcon, null))),
        react_1.default.createElement("div", { title: tooltipMessages.redo },
            react_1.default.createElement(core_1.IconButton, { onClick: onRedoClick },
                react_1.default.createElement(icon_definitions_1.RedoIcon, null))),
        react_1.default.createElement("div", { title: tooltipMessages.removeSelected },
            react_1.default.createElement(core_1.IconButton, { onClick: onRemoveSelectedClick },
                react_1.default.createElement(icon_definitions_1.RemoveElementIcon, null))),
        react_1.default.createElement("div", { title: tooltipMessages.removeAll },
            react_1.default.createElement(core_1.IconButton, { onClick: onRemoveAllClick },
                react_1.default.createElement(icon_definitions_1.RemoveAllIcon, null)))));
});
exports.EditButtons.displayName = 'EditButtons';
var templateObject_1;
